import React, { useState, useEffect } from 'react';
import Logo from '../../../assets/images/common/comimport.png';
import { Link } from 'react-router-dom';
import { facebookIcon, instagramIcon, linkedinIcon, locationIcon, mailIcon, mobileIcon, nextVIcon, twitterIcon, whatsappIcon, youtubeIcon } from '../../../assets/icons';
import { FooterContent, FooterHowItWorks, FooterGetToKnowUs, FooterQuickLinks, importerrContact } from '../../../helper/constants';
import { getAuthLocalStorage } from '../../../../storage/localStorage';
import Maestro from '../../../assets/images/footer/maestro.png';
import MasterCard from '../../../assets/images/footer/master_card.png';
import Paypal from '../../../assets/images/footer/paypal.png';
import Rupay from '../../../assets/images/footer/rupay.png';
import Visa from '../../../assets/images/footer/visa.png';
import UPI from '../../../assets/images/footer/upi.png';
import Amazon from '../../../assets/images/footer/channel_partner/one.png';
import Shopify from '../../../assets/images/footer/channel_partner/two.png';
import Shiprocket from '../../../assets/images/footer/channel_partner/five.png';

import './style.css';

export default function WebFooter() {
  const [activeAccordion, setActiveAccordion] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  const auth = getAuthLocalStorage();
  const isLoggedIn = !!(auth?.isLoggedIn && auth?.loginHeader);

  const socialMedia = [
    { icon: linkedinIcon, link: 'https://www.linkedin.com/company/importerr/?viewAsMember=true' },
    {
      icon: facebookIcon,
      link: 'https://www.facebook.com/profile.php?id=61581809109299',
    },
    {
      icon: instagramIcon,
      link: 'https://www.instagram.com/importerr_?igsh=MWZiaG1lYW92dXJtaw==',
    },
    { icon: youtubeIcon, link: 'https://youtube.com/@importerr?si=esZRhh9T-SsbiCbP' },
  ];

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const toggleAccordion = index => {
    if (!isMobile) return;
    setActiveAccordion(activeAccordion === index ? null : index);
  };

  return (
    <div className="web_footer_bg">
      <div className="web_footer_row">
        <div className="web_footer_col web_footer_col_one">
          <div className="web_footer_col_one_text">
            <Link className="footer_logo" to="/">
              <img src={Logo} alt="Importerr Logo" />
            </Link>
            <p className="web_footer_col_para">{FooterContent.about}</p>
            <Link className="footer_view_more_btn" to="/about-us">
              View More <span>{nextVIcon}</span>
            </Link>
          </div>

          <SocialMedia socialMedia={socialMedia} />
        </div>

        {/* Contact Section - No Accordion */}
        <div className="web_footer_col web_footer_col_two">
          <h2 className="web_footer_col_head">{FooterContent.headOne}</h2>
          <Link className="web_footer_link" to={`mailto:${importerrContact.email}`}>
            <div>{mailIcon}</div>
            <p>{importerrContact.email}</p>
          </Link>
          <Link className="web_footer_link" to="tel:+917827842406" target="_blank">
            <div>{mobileIcon}</div>
            <p>{importerrContact.phone}</p>
          </Link>
        </div>

        {/* Other Sections with Accordion */}
        <div className={`web_footer_col ${activeAccordion === 2 ? 'active' : ''}`}>
          <h2 className="web_footer_col_head" onClick={() => toggleAccordion(2)}>
            {FooterContent.headTwo}
          </h2>
          {FooterHowItWorks.map((item, index) => (
            <Link className="web_footer_link" to={item.link} key={index}>
              {item.name}
            </Link>
          ))}
        </div>

        <div className={`web_footer_col ${activeAccordion === 3 ? 'active' : ''}`}>
          <h2 className="web_footer_col_head" onClick={() => toggleAccordion(3)}>
            {FooterContent.headThree}
          </h2>
          {FooterGetToKnowUs.map((item, index) => (
            <Link className="web_footer_link" to={item.link} key={index}>
              {item.name}
            </Link>
          ))}
        </div>

        <div className={`web_footer_col ${activeAccordion === 4 ? 'active' : ''}`}>
          <h2 className="web_footer_col_head" onClick={() => toggleAccordion(4)}>
            {FooterContent.headFour}
          </h2>
          {FooterQuickLinks.map((item, index) => (
            <Link className="web_footer_link" to={item.link} key={index}>
              {item.name}
            </Link>
          ))}
          {auth?.isAffiliate ? (
            <Link className="web_footer_link web_footer_affiliate_btn" to="/seller/affiliate/dashboard">
              Affiliate Portal
            </Link>
          ) : (
            <Link className="web_footer_link web_footer_affiliate_btn" to="/signup?affiliate=1">
              Become Affiliator
            </Link>
          )}
        </div>
      </div>

      <div className="web_footer_row_two">
        <p>© 2025, (Boundless Trends Private Limited) Importerr All rights reserved.</p>
        <div className="partners_and_payments">
          <span className="partners_text">Our Partners</span>
          <div className="payment_cards_row">
            <div className="payment_cards_img_container">
              <img src={Amazon} alt="Amazon" />
            </div>
            <div className="payment_cards_img_container">
              <img src={Shopify} alt="Shopify" />
            </div>
            <div className="payment_cards_img_container">
              <img src={Shiprocket} alt="Shiprocket" />
            </div>
            <div className="payment_cards_img_container">
              <img src={Paypal} alt="Paypal" />
            </div>
            <div className="payment_cards_img_container">
              <img src={Rupay} alt="Rupay" />
            </div>
            <div className="payment_cards_img_container">
              <img src={Visa} alt="Visa" />
            </div>
            <div className="payment_cards_img_container">
              <img src={Maestro} alt="Maestro" />
            </div>
            <div className="payment_cards_img_container">
              <img src={MasterCard} alt="MasterCard" />
            </div>
            <div className="payment_cards_img_container">
              <img src={UPI} alt="UPI" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const SocialMedia = ({ socialMedia }) => {
  return (
    <div className="social_media_row">
      {socialMedia.map((item, index) => (
        <Link
          to={item.link}
          key={index}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`Follow us on ${
            item.link.includes('linkedin') ? 'LinkedIn' : item.link.includes('facebook') ? 'Facebook' : item.link.includes('instagram') ? 'Instagram' : 'YouTube'
          }`}
        >
          <div>{item.icon}</div>
        </Link>
      ))}
    </div>
  );
};
